import type { PhotoGridProps } from '@/app/components/PhotoGrid/types';

export const mobileOR4PhotoGrid: PhotoGridProps = {
  className: 'grid-cols-10 flex items-center w-[110vw]',
  columns: [
    {
      colSpan: 4,
      id: 'mobile-grid-col-1',
      items: [
        {
          alt: 'design_image_alt_1',
          className: 'h-[197px]',
          dimensions: { height: 197, width: 156 },
          id: 'mobile-grid-col-1-item-1',
          src: 'blue-sky/why-oura/or4-xray-mobile.jpg',
        },
        {
          alt: 'design_image_alt_4',
          className: 'h-[176px]',
          dimensions: { height: 176, width: 196 },
          id: 'mobile-grid-col-3-item-1',
          offset: { x: 0.5, y: 0.55 },
          src: 'blue-sky/why-oura/stealth-finish.jpg',
        },
      ],
    },
    {
      colSpan: 6,
      id: 'mobile-grid-col-2',
      items: [
        {
          alt: 'design_image_alt_3',
          dimensions: { height: 300, width: 248 },
          id: '',
          src: 'blue-sky/why-oura/or4-materials-mobile.jpg',
          trimColor: '0a031d',
          offset: { x: 0, y: 0.55 },
          zoom: 1.1,
        },
        {
          alt: 'design_image_alt_2',
          dimensions: { height: 185, width: 212 },
          id: 'mobile-grid-col-1-item-2',
          src: 'blue-sky/why-oura/or4-dimple-mobile.jpg',
        },
      ],
    },
  ],
};

export const desktopOR4PhotoGrid: PhotoGridProps = {
  className: 'grid-cols-12 max-w-[1440px]',
  columns: [
    {
      colSpan: 4,
      id: 'desktop-grid-col-1',
      items: [
        {
          alt: 'design_image_alt_1',
          dimensions: { height: 210, width: 405 },
          id: 'desktop-grid-col-1-item-1',
          src: 'blue-sky/why-oura/or4-xray.jpg',
        },
        {
          alt: 'design_image_alt_2',
          className: 'h-[452px]',
          dimensions: { height: 452, width: 405 },
          id: 'desktop-grid-col-1-item-2',
          src: 'blue-sky/why-oura/or4-dimple.jpg',
        },
      ],
    },
    {
      colSpan: 4,
      id: 'desktop-grid-col-2',
      items: [
        {
          alt: 'design_image_alt_3',
          className: 'h-[576px]',
          dimensions: { height: 576, width: 479 },
          id: '',
          src: 'blue-sky/why-oura/or4-materials.jpg',
          trimColor: '0a031d',
        },
      ],
    },
    {
      colSpan: 4,
      id: 'desktop-grid-col-3',
      items: [
        {
          alt: 'design_image_alt_4',
          dimensions: { height: 449, width: 403 },
          id: 'desktop-grid-col-3-item-1',
          src: 'blue-sky/why-oura/stealth-finish.jpg',
        },
      ],
    },
  ],
};
